
const DateUtil = {
  install (Vue) {
    Vue.prototype.$dateUtil = DateUtil
  },
  getSecondByHm (time) {
    let hour = time.split(':')[0]
    let minute = time.split(':')[1]
    return hour * 3600 + minute * 60
  }


}
export default DateUtil



// WEBPACK FOOTER //
// ./src/plugins/DateUtil.js